
import {PropertyBase} from "./PropertyBase";
import * as React from "react";
declare let rednaoPDFInvoiceParams:any;
let media_uploader:any;
let wp:any;

export class ImageProperty extends PropertyBase{
    public label:string='Selected Image';
    public $img:JQuery;
    private elementID:string;
    private media:any=null;
    private width=200;


    protected InternalGenerationCompleted($element:JQuery) {


    }

    public SetWidth(width:number)
    {
        this.width=width;
        return this;
    }


    public SubRenderer(): React.ReactNode {
        return (
            <div>
                <label>{this.label}</label>
                <img style={{maxWidth:this.width,display:'block',margin:'auto',border:'1px solid #dfdfdf',cursor:'pointer'}} onClick={e=>this.ChangeImage()} src={this.Options['URL']}/>
            </div>
        )
    }


    private ChangeImage() {
        if(this.media==null)
        {
            this.media = (window as any).wp.media({
                title: "Which image do you want to use in your pdf?",
                multiple: false,
                button: {
                    text: 'Select an image'
                }
            });

            this.media.on('select',  ()=> {
                let selection = this.media.state().get('selection');
                console.log(selection);
                if (selection == null)
                    return;
                selection.each((attachment) =>{
                    this.Options['URLId']=attachment.attributes.id;
                    this.SetOptionValue(attachment.attributes.url);
                    this.ForceUpdate();
                });

            });
        }

        this.media.open();
    }
}

